import React from 'react';

import _ from 'lodash';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

const styles = {
  label: {
    color: 'grey',
    fontSize: 12,
  }
}

const LocationInput = ({ label, value = {}, onChange }) => {
  return (<Grid container spacing={8}>
    {label ? <Grid item xs={12}><span style={styles.label}>{label}</span></Grid> : null }
    <Grid item xs={4}>
      <TextField
        name="building"
        label="Building"
        fullWidth
        value={value.building || ''}
        onChange={(evt) => onChange(_.assign({}, value, { building: evt.target.value }))}
      />
    </Grid>
    <Grid item xs={4}>
      <TextField
        name="floor"
        label="Floor"
        fullWidth
        value={value.floor || ''}
        onChange={(evt) => onChange(_.assign({}, value, { floor: evt.target.value }))}
      />
    </Grid>
    <Grid item xs={4}>
      <TextField
        name="space"
        label="Space"
        fullWidth
        value={value.space || ''}
        onChange={(evt) => onChange(_.assign({}, value, { space: evt.target.value }))}
      />
    </Grid>
  </Grid>);
};

export default LocationInput;



// WEBPACK FOOTER //
// ./src/components/Common/LocationInput/index.js